export default __webpack_public_path__ + "static/media/organic (2).71a214ff.png";